import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ServersService} from '../../services/servers.service';
import {ServerModel} from '../../models/server.model';
import {SensorModel} from "../../models/sensor.model";
import {SensorsService} from "../../services/sensors.service";

@Component({
  selector: 'lba-select-sensor',
  templateUrl: './select-sensor.component.html',
  styleUrls: ['./select-sensor.component.scss'],
})
export class SelectSensorComponent implements OnInit, OnDestroy {

  searchStr: string = '';

  sensors: SensorModel[];

  sensorName: string = 'Select Sensor';

  subscription: Subscription;

  isLoaded: boolean = false;

  serverId: number;

  constructor(
    private activeModal: NgbActiveModal,
    private sensorsService: SensorsService,
  ) {
  }

  ngOnInit() {
    this.subscription = this.sensorsService.getSensors()
      .subscribe((data: SensorModel[]) => {
          this.sensors = data.filter(sensor => sensor.serverId === this.serverId);
          this.isLoaded = true;
        },
        error => {
          console.log(error);
          window.alert('Error: ' + error.message + ', error status: ' + error.status);
        });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  selectSensor(selectedObject: ServerModel) {
    this.activeModal.close(selectedObject);
  }

}

